import {
	ADD_DOCTORS_REQUEST,
	ADD_DOCTORS_SUCCESS,
	ADD_DOCTORS_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const addNewDoctorReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_DOCTORS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case ADD_DOCTORS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case ADD_DOCTORS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default addNewDoctorReducer